import { render } from "./BackupMetadata.vue?vue&type=template&id=18688c8a"
import script from "./BackupMetadata.vue?vue&type=script&lang=js"
export * from "./BackupMetadata.vue?vue&type=script&lang=js"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.23.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__